import React, { Component } from 'react'

import classes from './SetupForm.scss'
import moment from 'moment'

import {
  checkValidity,
  updateFormOptions,
  updateFilterOptions,
  getPageStatus,
  updateObject,
  extractFilterOptions,
  validateForm
} from '../../../../helpers/utils'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Alert from '../../../../components/Alert/Alert'
// import Button from '../../../../components/UI/Button/Button'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import DataTable from '../../../../components/DataTable/DataTable'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import Form from '../../../../components/PageContent/SetupData/SetupForm/Form/Form'
import Modal from '../../../../components/UI/Modal/Modal'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import { Edit, Delete, Add } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'
import Footer from '../../../../components/UI/Modal/Footer/Footer'
class SetupForm extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    action: 'add',
    actionRecordId: null,
    formValid: false,
    addAno: false,
    searchText: '',
    withSeq: true,
    filter: {},
    inputGroups: {
      form_name: {
        label: this.props.translate('formName'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('formName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      company_id: {
        label: this.props.translate('company'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('company') }
          ]
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      appraisal_year: {
        label: this.props.translate('appraisalYear'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('appraisalYear'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('appraisalYear')
            }
          ]
        },
        value: { value: new Date().getFullYear(), label: new Date().getFullYear().toString() },
        validation: {
          required: true
        },
        valid: true,
        touched: false,
        error: null
      },
      result_type_id: {
        label: this.props.translate('resultType'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('resultType'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('resultType')
            }
          ]
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      start_date: {
        label: this.props.translate('startDate'),
        elementType: 'datePicker',
        elementConfig: {
          minDate: new Date(new Date().getFullYear(), 0, 1)
        },
        value: null,
        validation: {
          required: true,
          type: 'date'
        },
        valid: false,
        touched: false,
        error: null
      },
      end_date: {
        label: this.props.translate('endDate'),
        elementType: 'datePicker',
        elementConfig: {
          minDate: new Date(new Date().getFullYear(), 0, 1)
        },
        value: null,
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      budget_salary: {
        label: this.props.translate('budgetSalary'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('budgetSalary')
        },
        value: '',
        validation: {
          required: false
        },
        valid: false,
        touched: false,
        error: null
      },
      budget_bonus: {
        label: this.props.translate('budgetBonus'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('budgetBonus')
        },
        value: '',
        validation: {
          required: false
        },
        valid: false,
        touched: false,
        error: null
      },
      is_force_rank: {
        label: this.props.translate('isForceRank'),
        elementType: 'checkbox',
        elementConfig: {
          placeholder: this.props.translate('isForceRank')
        },
        value: false,
        validation: {
          required: false
        },
        valid: false,
        touched: false,
        error: null
      }
    },
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('company') }
          ]
        }
      },
      form_id: {
        label: this.props.translate('formName'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('formName'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('formName') }
          ]
        }
      },
      appraisal_year: {
        label: this.props.translate('appraisalYear'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('appraisalYear'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('appraisalYear')
            }
          ]
        }
      }
    },
    updateProps: {
      selectedRecord: this.props.selectedRecord,
      companyOptions: this.props.companyOptions,
      appraisalYearOptions: this.props.appraisalYearOptions,
      resultTypeOptions: this.props.resultTypeOptions,
      filterForm: this.props.filterForm
    }
  }

  rowActions = [
    {
      icon: () => <Add />,
      tooltip: this.props.translate('add') + this.props.translate('form'),
      onClick: () => this.openModalHandler('add'),
      isFreeAction: true,
      disabled: !this.props.pagePermission.is_add
    },
    {
      icon: () => <Edit fontSize={'small'} />,
      tooltip: this.props.translate('edit') + this.props.translate('form'),
      onClick: (event, rowData) => this.openModalHandler('edit', rowData.form_id),
      disabled: !this.props.pagePermission.is_edit
    },
    {
      icon: () => <Delete fontSize={'small'} />,
      tooltip: this.props.translate('delete') + this.props.translate('form'),
      onClick: (event, rowData) => this.openModalHandler('delete', rowData.form_id),
      disabled: !this.props.pagePermission.is_delete
    }
  ]

  tableStructure = [
    {
      field: 'index',
      title: '#',
      width: 70
    },
    { field: 'form_name', title: this.props.translate('formName'), type: 'string' },
    { field: 'company_name', title: this.props.translate('company'), type: 'string' },
    {
      field: 'appraisal_year',
      title: this.props.translate('appraisalYear'),
      type: 'string',
      width: 150
    },
    { field: 'start_date', title: this.props.translate('startDate'), type: 'string', width: 150 },
    { field: 'end_date', title: this.props.translate('endDate'), type: 'string', width: 150 }
  ]

  componentDidMount() {
    this.props.fetchOptions()
    this.props.fetchForm()
  }
  componentDidUpdate(prevprops) {
    if (prevprops.success !== this.props.success && this.props.success) {
      this.clearModal()
    }
  }
  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    let { updateProps } = state
    const updateOptions = (stateId, propsId, attr) => {
      const inputGroups = state.inputGroups
      const targetLevelItem = inputGroups[stateId]
      let [attrId, attrName, attrPlaceHolder] = attr

      updatedState = updateObject(updatedState, {
        inputGroups: updateObject(inputGroups, {
          [stateId]: updateFormOptions(
            props[propsId],
            targetLevelItem,
            attrId,
            attrId,
            attrName,
            attrPlaceHolder
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    const updateFilter = (stateId, propsId, attr) => {
      let [attrId, attrName] = attr

      updatedState = updateObject(updatedState, {
        filterControls: updateObject(state.filterControls, {
          [stateId]: updateFilterOptions(
            props[propsId],
            state.filterControls[stateId],
            attrId,
            attrId,
            attrName,
            null,
            null,
            state.filterControls[stateId].value
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    if (props.companyOptions !== updateProps.companyOptions) {
      updateOptions('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' },
        'Select Company'
      ])
      updateFilter('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' }
      ])
    }
    if (props.appraisalYearOptions !== updateProps.appraisalYearOptions) {
      updateOptions('appraisal_year', 'appraisalYearOptions', [
        'year_code',
        'year_name',
        'Select Appraisal Year'
      ])
      updateFilter('appraisal_year', 'appraisalYearOptions', ['year_code', 'year_name'])
    }
    if (props.resultTypeOptions !== updateProps.resultTypeOptions) {
      updateOptions('result_type_id', 'resultTypeOptions', [
        'value_list_id',
        { code: 'value_list_code', name: 'value_list_name' },
        'Select Type'
      ])
    }
    if (props.filterForm !== updateProps.filterForm) {
      updateFilter('form_id', 'filterForm', ['form_id', 'form_name'])
    }

    if (props.selectedRecord !== updateProps.selectedRecord) {
      let newFormData = Object.entries(state.inputGroups).reduce((formGroups, form) => {
        let [formKey, formAttrs] = form
        let value = ''
        let valid = false
        let touched = false
        let errorMessage = null
        if (!formAttrs.validation || !formAttrs.validation.required) {
          valid = true
        }
        if (props.selectedRecord && props.selectedRecord[formKey]) {
          value = props.selectedRecord[formKey] || null

          let { isValid, error } = checkValidity(value, formAttrs.validation, formAttrs.label)
          if (formAttrs.elementType === 'newselect') {
            value = state.inputGroups[formKey].elementConfig.options.find(
              res => res.value === value
            )
          }
          valid = isValid
          errorMessage = error
        }

        const newFormAttrs = {
          ...formAttrs,
          value: value,
          valid: valid,
          error: errorMessage,
          touched: touched
        }

        return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
      }, {})

      newFormData = updateObject(newFormData, {
        start_date: {
          ...newFormData.start_date,
          value: newFormData.start_date.value ? new Date(newFormData.start_date.value) : null
        },
        end_date: {
          ...newFormData.end_date,
          value: newFormData.start_date.value ? new Date(newFormData.end_date.value) : null
        }
      })

      updatedState = {
        ...updatedState,
        formValid: true,
        inputGroups: newFormData,
        updateProps: {
          ...updateProps,
          selectedRecord: props.selectedRecord
        }
      }
    }
    return updatedState
  }
  onPageChangeHandler = (e, page) => {
    const pageOptions = {
      page: page,
      perPage: this.props.pagination.perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchForm(payload)
  }

  onPerPageChangeHandler = perPage => {
    const pageOptions = {
      page: this.props.pagination.currentPage,
      perPage: perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchForm(payload)
  }

  searchInputChangeHandler = e => {
    const searchText = e.target.value
    this.setState({
      searchText: searchText
    })
  }
  clearInput = () => {
    let newFormData = Object.entries(this.state.inputGroups).reduce((formGroups, form) => {
      let [formKey, formAttrs] = form
      let newFormAttrs
      switch (formKey) {
        case 'appraisal_year':
          newFormAttrs = {
            ...formAttrs,
            value: new Date().getFullYear()
          }
          break
        case 'start_date':
          newFormAttrs = {
            ...formAttrs,
            value: null,
            elementConfig: {
              placeholder: 'Select Start Date',
              minDate: new Date(new Date().getFullYear(), 0, 1)
            }
          }
          break
        case 'end_date':
          newFormAttrs = {
            ...formAttrs,
            value: null,
            elementConfig: {
              placeholder: 'Select End Date',
              minDate: new Date(new Date().getFullYear(), 0, 1)
            }
          }
          break

        default:
          newFormAttrs = {
            ...formAttrs,
            value: ''
          }
          break
      }

      return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
    }, {})
    this.setState({ inputGroups: newFormData })
  }
  openModalHandler = (action, recordId) => {
    if (recordId && action === 'edit') {
      this.props.fetchFormById(recordId)
    }
    this.setState({
      action: action,
      actionRecordId: recordId
    })

    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else {
      this.props.fetchOptions()
      this.openModal()
    }
  }

  openModal = () => {
    this.setState({
      modalOpen: true
    })
  }

  closeModal = () => {
    if (this.state.action === 'edit') {
      this.clearModal()
    } else {
      this.setState({
        modalOpen: false
      })
    }
  }
  clearModal = () => {
    this.clearInput()
    this.props.clearSelectedRecord()
    if (this.state.addAno) {
      this.setState({
        actionRecordId: null,
        formValid: false,
        addAno: false
      })
    } else {
      this.setState({
        actionRecordId: null,
        formValid: false,
        modalOpen: false
      })
    }
  }
  formSubmitHandler = type => {
    // e.preventDefault()

    const formData = Object.entries(this.state.inputGroups).reduce((formData, formEntry) => {
      let [formKey, formAttrs] = formEntry
      let value = ''
      console.log(formKey, formAttrs)
      if (formAttrs.elementType === 'datePicker') {
        value = moment(formAttrs.value).format('YYYY-MM-DD')
      } else if (formAttrs.elementType === 'newselect') {
        value = formAttrs.value?.value
      } else if (formAttrs.elementType === 'checkbox') {
        value = formAttrs.value ? 1 : 0
      } else {
        value = formAttrs.value
      }
      return { ...formData, [formKey]: value }
    }, {})
    console.log(formData)
    if (this.state.action === 'add') {
      this.props.createForm({ ...formData }, getPageStatus(this.props.pagination, false))
      if (type === 'saveAno') {
        this.setState({
          addAno: true
        })
      }
    } else if (this.state.action === 'edit') {
      this.props.updateForm(
        this.state.actionRecordId,
        { ...formData },
        getPageStatus(this.props.pagination, false)
      )
    }
  }

  inputChangeHandler = (groupKey, formKey, event) => {
    const inputGroup = this.state.inputGroups
    const formItem = inputGroup[formKey]
    let inputValue = ''

    switch (formItem.elementType) {
      case 'newselect':
        inputValue = event
        break
      case 'datePicker':
        inputValue = event
        break
      case 'checkbox':
        inputValue = !formItem.value
        break
      default:
        inputValue = event.target.value
        break
    }

    const { isValid, error } = checkValidity(inputValue, formItem.validation, formItem.label)

    const updatedFormItem = {
      ...formItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }

    let formIsValid = true
    const updateGroup = updateObject(inputGroup, { [formKey]: updatedFormItem })

    Object.values(updateGroup).map(attr => {
      return (formIsValid = formIsValid && attr.valid)
    })
    if (formKey === 'start_date') {
      this.setState({
        inputGroups: updateObject(inputGroup, {
          [formKey]: updatedFormItem,
          end_date: {
            ...inputGroup.end_date,
            elementConfig: {
              ...inputGroup.end_date.elementConfig,
              minDate: new Date(inputValue)
            }
          }
        }),
        formValid: formIsValid
      })
    } else if (formKey === 'appraisal_year') {
      this.setState({
        inputGroups: updateObject(inputGroup, {
          [formKey]: updatedFormItem,
          start_date: {
            ...inputGroup.start_date,
            elementConfig: {
              ...inputGroup.end_date.elementConfig,
              minDate: new Date(inputValue?.value, 0, 1)
            }
          }
        }),
        formValid: formIsValid
      })
    } else {
      this.setState({
        inputGroups: updateObject(inputGroup, { [formKey]: updatedFormItem }),
        formValid: formIsValid
      })
    }
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false
    })
  }

  openConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: true
    })
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    let filterControls = this.state.filterControls

    Object.entries(filterControls).map((data, key) => {
      let [datakey] = data

      return (filterControls = {
        ...filterControls,
        [datakey]: { ...filterControls[datakey], value: '' }
      })
    })

    this.props.fetchFilter()

    this.setState({
      filterModalOpen: true,
      filterControls: filterControls,
      filter: []
    })
  }
  deleteRecord = () => {
    const recordId = this.state.actionRecordId

    this.props.deleteForm(recordId, getPageStatus(this.props.pagination, true))

    this.closeConfirmationModal()
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]

    this.setState({
      filterControls: updateObject(this.state.filterControls, {
        [itemKey]: {
          ...filterItem,
          value: filterValue
        }
      }),
      filter: { ...this.state.filter, [itemKey]: filterValue?.value }
    })
  }

  filterRecords = () => {
    this.props.fetchForm(this.state.filter)
    this.closeFilterModal()
  }

  render() {
    let formLabel = <Spinner />
    if (!this.props.loading) {
      formLabel = Object.entries(this.state.inputGroups).map((item, key) => {
        return (
          <Form
            key={key}
            form={item}
            inputChanged={(formKey, e) => this.inputChangeHandler(key, formKey, e)}
            formValid={this.state.formIsValid}
          />
        )
      })
    }
    // const buttonGroups = (
    //   <div className={classes.ButtonGroup}>
    //     <span className={classes.Button}>
    //       <Button
    //         color={'primary'}
    //         clicked={this.formSubmitHandler}
    //         disabled={!this.state.formValid}>
    //         Save
    //       </Button>
    //     </span>
    //     <span className={classes.Button}>
    //       <Button color={'default'} clicked={this.clearModal}>
    //         Cancel
    //       </Button>
    //     </span>
    //   </div>
    // )
    const footer = (
      <Footer
        save={() => this.formSubmitHandler('save')}
        another={() => this.formSubmitHandler('saveAno')}
        showAnother={this.state.action === 'add'}
        cancel={() => this.closeModal()}
        disable={!validateForm(this.state.inputGroups)}
      />
    )
    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
        />
        <Alert />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={this.props.translate(this.state.action) + this.props.translate('form')}
          backdropClicked={this.closeModal}
          footer={footer}>
          <div className={classes.ModalBody}>{formLabel}</div>
        </Modal>
        <Card>
          <CardHeader>
            <FilterBar buttonClicked={this.openFilterModal} />
          </CardHeader>
          <CardBody>
            <DataTable
              tableTitle={this.props.translate('form')}
              data={this.props.data}
              structure={this.tableStructure}
              loading={this.props.loadingQueue.includes('record')}
              pagination={this.props.pagination}
              pageChange={this.onPageChangeHandler}
              perPageChange={this.onPerPageChangeHandler}
              rowActions={this.rowActions}
            />
          </CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.form.pagination,
    data: state.form.records,
    loading: state.form.loading,
    filterLoading: state.form.filterLoading,
    success: state.form.success,
    selectedRecord: state.form.selectedRecord,
    companyOptions: state.form.company,
    appraisalYearOptions: state.form.appraisalYear,
    resultTypeOptions: state.form.resultType,
    filterForm: state.form.filterForm,
    loadingQueue: state.form.loadingStates
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchForm: filterOptions => dispatch(actions.fetchForm(filterOptions)),
    fetchFormById: recordId => dispatch(actions.fetchFormById(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedFormRecord()),
    createForm: (recordData, page) => dispatch(actions.createForm(recordData, page)),
    updateForm: (recordId, recordData, page) =>
      dispatch(actions.updateForm(recordId, recordData, page)),
    deleteForm: (recordId, page) => dispatch(actions.deleteForm(recordId, page)),
    fetchOptions: () => {
      dispatch(actions.fetchCompanyOptions())
      dispatch(actions.fetchAppraisalYearOptions())
      dispatch(actions.fetchResultTypeOptions())
    },
    fetchFilter: () => {
      dispatch(actions.fetchCompanyOptions())
      dispatch(actions.fetchAppraisalYearOptions())
      dispatch(actions.fetchFormOptions())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(SetupForm))
